// extracted by mini-css-extract-plugin
module.exports = {"root":"HSrDCZ","header":"JrcL8L","content":"DMH_hI","title":"CQZYiH","subtitle":"yvs3vA","mobile":"lHJB2S"};